import {
  Cpu,
  Waypoints,
  Network,
  Wifi,
  PhoneCall,
  Cloud,
  MessageSquare,
  PhoneOutgoing,
  MessageCircle,
  Headphones,
  Bot,
  ShieldAlert,
  ShieldCheck,
  Router,
  Wrench,
  GraduationCap,
  Building2,
  Cog,
  Factory,
  HeartPulse,
  ShoppingBag,
  BookOpen,
  Truck,
  Landmark,
} from "lucide-react";

export const SERVICES = [
  {
    tag: "M365 · Azure · Volume",
    title: "Microsoft Licensing",
    desc: "Optimised Microsoft 365, Azure and volume licensing programs with expert advisory.",
    icon: Cpu,
  },
  {
    tag: "Application-Aware WAN",
    title: "SD-WAN",
    desc: "Secure, software-defined WAN with intelligent path selection and application QoS.",
    icon: Waypoints,
  },
  {
    tag: "Carrier-Grade Private WAN",
    title: "MPLS",
    desc: "Reliable multi-site private connectivity with guaranteed SLAs across India and APAC.",
    icon: Network,
  },
  {
    tag: "Dedicated · Symmetric",
    title: "Internet Leased Line",
    desc: "Business-grade dedicated internet with symmetric bandwidth and 99.9% uptime SLA.",
    icon: Wifi,
  },
  {
    tag: "PSTN Replacement",
    title: "SIP Trunk",
    desc: "Cost-effective SIP trunking for IP-PBX with pan-India DIDs and toll-free numbers.",
    icon: PhoneCall,
  },
  {
    tag: "Hosted PBX",
    title: "Cloud Telephony",
    desc: "Fully hosted enterprise phone systems with IVR, call recording and analytics.",
    icon: Cloud,
  },
  {
    tag: "Direct Routing",
    title: "MS Teams PSTN",
    desc: "Enable PSTN calling on Microsoft Teams via Direct Routing / Operator Connect.",
    icon: MessageSquare,
  },
  {
    tag: "Cisco Cloud Calling",
    title: "Webex Calling",
    desc: "Cisco Webex Calling with global PSTN, meetings and collaboration built-in.",
    icon: PhoneOutgoing,
  },
  {
    tag: "Verified BSP",
    title: "WhatsApp Business",
    desc: "Verified WhatsApp Business API for support, notifications and conversational commerce.",
    icon: MessageCircle,
  },
  {
    tag: "Omnichannel Contact",
    title: "CPaaS & CCaaS",
    desc: "Omnichannel communication platforms and cloud contact centre for CX at scale.",
    icon: Headphones,
  },
  {
    tag: "Conversational AI",
    title: "AI Voice Bots",
    desc: "Human-like AI voice bots for inbound support and outbound campaigns.",
    icon: Bot,
  },
  {
    tag: "XDR · EDR · Firewall",
    title: "Cyber Security",
    desc: "End-to-end cyber defence: EDR, XDR, email, endpoint and perimeter security.",
    icon: ShieldAlert,
  },
  {
    tag: "Zero-Trust Edge",
    title: "SASE Solutions",
    desc: "Secure Access Service Edge combining SD-WAN, ZTNA, CASB, SWG and FWaaS.",
    icon: ShieldCheck,
  },
  {
    tag: "LAN · Wi-Fi 6/7",
    title: "Network Infrastructure",
    desc: "Enterprise LAN, WAN, Wi-Fi 6/7 and structured cabling designed for resilience.",
    icon: Router,
  },
  {
    tag: "Managed IT",
    title: "Corporate IT Solutions",
    desc: "End-to-end IT lifecycle — procurement, deployment, monitoring and support.",
    icon: Wrench,
  },
  {
    tag: "Certified Programs",
    title: "Technical Training",
    desc: "Certified enterprise IT and networking training for individuals and teams.",
    icon: GraduationCap,
  },
];

export const INDUSTRIES = [
  { name: "BFSI", icon: Building2 },
  { name: "IT / ITES", icon: Cog },
  { name: "Manufacturing", icon: Factory },
  { name: "Healthcare", icon: HeartPulse },
  { name: "Retail & E-commerce", icon: ShoppingBag },
  { name: "Education", icon: BookOpen },
  { name: "Logistics", icon: Truck },
  { name: "Government & PSU", icon: Landmark },
];
